export const gridColumnClasses = {
    oneColumn: '_grid-cols-1',
    twoColumns: '_grid-cols-2',
    threeColumns: '_grid-cols-3',
};

export const gridColumnSpanClasses = {
    oneColumn: '_col-span-1',
    twoColumns: '_col-span-2',
    threeColumns: '_col-span-3',
};

export const gridCellStatusColors = {
    default: '',
    good: 'gfu-table__cell--good',
    bad: 'gfu-table__cell--bad',
};

export const gridCellStatuses = {
    default: '',
    good: 'good',
    bad: 'bad',
};